export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const AUTH_LOG_ERROR = 'AUTH_LOG_ERROR';
export const AUTH_ASYNC_START = 'AUTH_ASYNC_START';
export const LOGIN_PAGE_UNLOADED = 'LOGIN_PAGE_UNLOADED';
export const SET_RESET_DETAILS = 'SET_RESET_DETAILS';
export const AUTH_TEAM_MEMBER_PASSWORD = 'AUTH_TEAM_MEMBER_PASSWORD';
export const CLEAR = 'CLEAR';
